import $ from 'static/script/libs/jquery'

let util = {};

util.redirectTo = function (url) {
    window.location.href = url;
};

util.serverLog = function (model) {
    $.ajax({
        type: 'POST',
        url: '/shopping/checkout2/clientlog/',
        data: model
    });
};

module.exports = util;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/checkout2/context/util.js